import { getEsimUpsellTicketIdsFromTicket } from 'loyalty/lib/esims/esimUpsellTicketUtils'
import { ESIM_HUBBY_UPSELL_OFFER_ID } from 'loyalty/constants/loyaltyEsimConstants'

type ExperienceLike =
  | App.Checkout.AnyItem
  | App.Checkout.ExperienceItem
  | App.Checkout.ExperienceItemView

interface LoyaltyEsimUpsellCartSelection {
  cartItem: App.Checkout.ExperienceItem
  selectedPackageTicketId: App.LoyaltyEsimUpsellTicketId | null
  baselinePackageTicketId: App.LoyaltyEsimUpsellTicketId | null
  countryCode: string | undefined
}

function readCartItem(item: ExperienceLike): App.Checkout.ExperienceItem | null {
  if ('item' in item) {
    return item.item
  }
  return item.itemType === 'experience' ? item : null
}

export default function isCheckoutEsimUpsellExperienceItem(item: ExperienceLike): boolean {
  const cartItem = readCartItem(item)
  const isEsimUpsellOffer = cartItem?.experienceId === ESIM_HUBBY_UPSELL_OFFER_ID

  return !!cartItem &&
    isEsimUpsellOffer &&
    !!cartItem.ticketModesMap?.['country-code'] &&
    !!cartItem.ticketModesMap?.['current-package']
}

export function getLoyaltyEsimUpsellCartItem(
  items: Array<App.Checkout.AnyItem>,
): App.Checkout.ExperienceItem | undefined {
  return items.find((item): item is App.Checkout.ExperienceItem => isCheckoutEsimUpsellExperienceItem(item))
}

export function getLoyaltyEsimUpsellCartSelection(
  items: Array<App.Checkout.AnyItem>,
): LoyaltyEsimUpsellCartSelection | undefined {
  const cartItem = getLoyaltyEsimUpsellCartItem(items)
  if (!cartItem) return undefined

  const countryCode = cartItem.ticketModesMap?.['country-code']
  const selectedTicket = cartItem.tickets[0]
  const { toTicketId, fromTicketId } = selectedTicket
    ? getEsimUpsellTicketIdsFromTicket(selectedTicket)
    : { toTicketId: null, fromTicketId: null }

  return {
    cartItem,
    selectedPackageTicketId: toTicketId,
    baselinePackageTicketId: fromTicketId,
    countryCode,
  }
}
